module.exports = __webpack_public_path__ + "img/1546892635.1e38f926.jpg";